import { type FC } from 'react'
import './styles.css'

export const DotsLoader: FC = () => {
  return (
    <div className="flex items-center transition-all duration-500 ease-in-out z-[9999]">
      <div className="text-center z-[99999]">
        <div className="inline-block size-1.5 bg-black rounded-full animate-dotsScale" />
        <div
          className="inline-block size-1.5 bg-black rounded-full animate-dotsScale mx-1"
          style={{ animationDelay: '0.16s' }}
        />
        <div
          className="inline-block size-1.5 bg-black rounded-full animate-dotsScale"
          style={{ animationDelay: '0.32s' }}
        />
      </div>
    </div>
  )
}
